import React, { Fragment } from 'react';
import { ItemListSection } from '../../ItemListSection/ItemListSection';
import { ItemListConfig, ItemValueType } from '../../../../../../Models';
import { SaveObjectPanel } from '../../../../../../Components/SaveObjectPanel/SaveObjectPanel';
import { ItemForm } from '../../ItemForm/ItemForm';
import { useOtherAgenciesInvolvedFormView } from './Hooks/useOtherAgenciesInvolvedFormView';

export interface OtherAgenciesInvolvedFormProps {
  config: ItemListConfig;
  agencies: ItemValueType[];
  onChange: (agencies: ItemValueType[]) => void;
}

export const OtherAgenciesInvolvedForm = ({
  config,
  agencies,
  onChange
}: OtherAgenciesInvolvedFormProps): React.ReactElement<OtherAgenciesInvolvedFormProps> => {
  const {
    showStateRelated,
    selectedAgency,
    agencyValue,
    isOtherAgencyPanelOpen,
    isAgencySaveDisabled,
    onAddAgency,
    onSelectAgency,
    onDuplicateAgency,
    onRemoveAgency,
    onSaveAgency,
    onCloseAgencyPanel,
    onItemFormChange
  } = useOtherAgenciesInvolvedFormView({ config, agencies, onChange });

  return (
    <Fragment>
      <SaveObjectPanel
        title={`Other Agency ${
          selectedAgency === -1 ? agencies.length + 1 : selectedAgency + 1
        }`}
        isOpen={isOtherAgencyPanelOpen}
        isSaveDisabled={isAgencySaveDisabled}
        saveBtnLabel={selectedAgency !== -1 ? 'Save Changes' : 'Add Agency'}
        onClose={onCloseAgencyPanel}
        onSave={onSaveAgency}
      >
        <ItemForm
          sectionName="other_agencies_involved"
          config={config}
          value={agencyValue}
          onChange={onItemFormChange}
        />
      </SaveObjectPanel>

      <ItemListSection
        title="Other Agencies Involved"
        items={agencies}
        config={config}
        itemLabel="Other Agency"
        onAdd={onAddAgency}
        onSelect={onSelectAgency}
        onDuplicate={onDuplicateAgency}
        onRemove={onRemoveAgency}
        showStateMandated={showStateRelated}
      />
    </Fragment>
  );
};
